import { HttpClient } from '@angular/common/http';
import { Component, NgZone, OnInit, ViewChild, AfterViewInit } from '@angular/core';
import { AngularFireAuth } from '@angular/fire/auth';
import { FormBuilder, FormControl, FormGroup, ValidationErrors, ValidatorFn, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { Subscription } from 'rxjs/Subscription';
import { DataService } from 'src/app/services/data.service';
import { MatPaginator, PageEvent } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import { MatSort } from '@angular/material/sort';
import { TranslateService } from '@ngx-translate/core';
import { finalize, map, tap } from 'rxjs/operators';
import { FirebaseStorageService } from 'src/app/services/firebase-storage.service';

import { MatSnackBar } from '@angular/material/snack-bar';
import { CustomPopupComponent } from '../dialogs/custom-popup/custom-popup.component';

@Component({
  selector: 'app-orders-reportages',
  templateUrl: './orders-reportages.component.html',
  styleUrls: ['./orders-reportages.component.sass']
})
export class OrdersReportagesComponent implements OnInit {
  productsOrdered: any;
  productsOrder: any;
  orders: any;
  email: string;
  password3: string;
  confirmPassword: string;
  productsOrderedListSubs: Subscription;
  productsOrderedList: ProductOrdered[];
  reportagesListSubs: Subscription;
  reportages: any;
  stagesListSubs: Subscription;
  stages: any;
  gradesListSubs: Subscription;
  grades: any;
  // linesListSubs: Subscription;
  // lines: any;
  params: ProductOrdered[];
  isList: boolean = true;
  isNew: boolean = true;
  private routeSub: Subscription;
  type_accept: string;
  productOrderedForm: FormGroup;
  filterForm: FormGroup;
  pageEvent: PageEvent;
  modification_date: string;
  creation_date: string;
  reportage_name: string;
  readOnly: boolean = false;
  pageSize: number = 100;
  pageIndex: number = 0;
  totalItems: any;
  selectedFiles: File;
  selectedSecondaryFiles: File;
  product_ordered_photo: any;
  displayedColumns: string[] = ['name', 'reference', 'reportage', 'product_es', 'product_en', 'product_cat', 'quantity', 'actions'];
  displayedColumns2: string[] = ['name', 'product_name_es', 'product_name_en', 'product_name_cat', 'album_id', 'quantity', 'value', 'actions'];

  dataSource: ProductOrdered = null;
  reference: string;
  value: string;
  status: string;
  next_unprocessed: string;
  disable_next_unprocessed: string;
  dataSource2 = new MatTableDataSource<any>();
  disableClearFilterButton: boolean = true;
  yearperiods: any = []

  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort, {}) sort: MatSort;

  showOrderAdminProgressBar: boolean = true;
  showOrderAdminProgressBar2: boolean = true;

  selectedPrinter = 'print-1'

  constructor(
    public dataService: DataService,
    private http: HttpClient,
    public firebase: AngularFireAuth,
    private ngZone: NgZone,
    private router: Router,
    private route: ActivatedRoute,
    private formBuilder: FormBuilder,
    public translate: TranslateService,
    public firebaseStorageService: FirebaseStorageService,
    private snackbar: MatSnackBar
  ) { }

  public getReportageProductsOrdered() {
    this.productsOrderedListSubs = this.dataService
      .getReportageProductsOrdered('')
      .subscribe(res => {
        this.productsOrdered = res;
      },
        console.error
      );
  }

  public getReportages() {

    // Retrieve order school filter from local storage.
    let reportageFilter = localStorage.getItem("order_reportage_filter");

    var params = {};
    params['page'] = 1
    params['size'] = 100000
    params['search'] = ''
    params['unprocessed'] = this.filterForm.controls["unprocessed_only"].value;

    this.reportagesListSubs = this.dataService
      .getReportages(params)
      .subscribe(res => {
        this.reportages = res['items'];
        this.reportages = [{ 'id': null, 'name': "" }].concat(this.reportages)

        if (reportageFilter && reportageFilter != "null") {
          let callTableUpdates = true;

          // We loop through schools to make sure our filter matches existing school.
          res['items'].forEach(school => {
            // We update only if our filter matches an existing school ID, otherwise no filter is applied.
            if (school.id == reportageFilter) {
              this.filterForm.controls["reportages"].setValue(reportageFilter);
              callTableUpdates = false
              this.applyFilter();
            }
          });

          if (callTableUpdates) {
            this.showOrderAdminProgressBar = true
            var params = {};
            params['page'] = 1
            params['size'] = this.pageSize
            params['search'] = '';
            params['role'] = '';
            params['year_period'] = this.filterForm.controls["yearPeriod"].value;
            params['unprocessed'] = this.filterForm.controls["unprocessed_only"].value;
            
            this.fetchOrderedReportageProducts(params);
            this.fetchTotalOrderedReportageProducts(params);
          }


        }
      },
        console.error
      );
  }





  public clearFilterButtonState() {

    if (this.filterForm.controls["reportages"].value != '') {
      this.disableClearFilterButton = false;
    } else {
      this.disableClearFilterButton = true;
    }

  }


  ngOnInit() {
    this.type_accept = '.jpeg, .png, .jpg';
    this.dataService.getRole().subscribe(res => {
      if ((res != 'superadmin') && (res != 'admin')){
        this.router.navigate(['/welcome']);
      }

    });
    this.productOrderedForm = this.formBuilder.group({
      id: new FormControl(0, Validators.required),
      name: new FormControl('', Validators.required),
      email: new FormControl('', Validators.required),
      reportages: new FormControl('', Validators.required),
      num_list: new FormControl('', Validators.required),
    });


    let unprocessed_only_filter = true;

    if(localStorage.getItem('reportages_unprocessed_only_filter')){
      unprocessed_only_filter = localStorage.getItem('reportages_unprocessed_only_filter') == 'true' ? true : false
    }

    this.filterForm = this.formBuilder.group({
      reportages: new FormControl(null),
      unprocessed_only: new FormControl(unprocessed_only_filter),
      yearPeriod: new FormControl('')
    });


    this.routeSub = this.route.params.subscribe(params => {
      if (params.reference) {
        this.isList = false;
        if (params.reference != 'new') {
          this.isNew = false;
          this.productsOrderedListSubs = this.dataService
            .getOrder(params)
            .subscribe(res => {
              
              this.orders = res;
              // this.orderForm.controls["id"].setValue(this.orders.id);
              // this.orderForm.controls["reference"].setValue(this.orders.reference);
              // this.orderForm.controls["value"].setValue(this.orders.value);

              this.creation_date = this.orders.creation_date;
              this.modification_date = this.orders.modification_date;

              this.reference = this.orders.reference;
              this.value = this.orders.value;
              this.status = this.orders.status;
              this.product_ordered_photo = [{ "imageUrl": this.orders['product_photo'] }]
              this.dataService.getProductsOrder(params).subscribe(orders => {
                this.productsOrder = orders;
                this.reportage_name = orders[0].reportage_name
                this.dataSource2.data = this.productsOrder;
                this.showOrderAdminProgressBar2 = false;
                this.next_unprocessed = orders[0].next_unprocessed
                this.disable_next_unprocessed = orders[0].disable_next_unprocessed
              }),
                console.error

            });
        }
        else {
          this.isNew = true;
        }
      } else {
        this.isList = true;


      if(localStorage.getItem('order_year_period'))
      {
        this.filterForm.controls["yearPeriod"].setValue(localStorage.getItem('order_year_period'))
      }

        this.getYearPeriods()
        this.getReportages();

        if (!localStorage.getItem('order_reportage_filter')) {
          let params = {};
          params['page'] = 1
          params['size'] = this.pageSize
          params['search'] = '';
          params['reference'] = '';
          params['unprocessed'] = this.filterForm.controls["unprocessed_only"].value;
          params['year_period'] = this.filterForm.controls["yearPeriod"].value;

          this.fetchOrderedReportageProducts(params);
          this.fetchTotalOrderedReportageProducts(params);
        }
        else
        {
          //this.showOrderAdminProgressBar = false
        }
      }

    });
  }

  private fetchTotalOrderedReportageProducts(params = {}) {

    this.dataService.getTotalReportageProductsOrdered(params).pipe(
      map((totalItems) => this.totalItems = totalItems)
    ).subscribe();
  }

  private fetchOrderedReportageProducts(par: {}) {
    
    let params: any = {}
    
    if(par)
    {
      for(let key in par)
      {
        params[key] = par[key]
      }
    }
    
    if(localStorage.getItem('orders-reportages'))
    {
      let data = JSON.parse(localStorage.getItem('orders-reportages'))

      this.pageSize = data.pageSize
      
      this.pageIndex = data.page-1

      params['page'] = this.pageIndex+1

      params['size'] = this.pageSize
    }

    params['year_period'] = this.filterForm.controls["yearPeriod"].value;

    this.filterForm.disable();

    this.dataService.getReportageProductsOrdered(params).pipe(
      map((tableData: ProductOrdered) => this.dataSource = tableData)
    ).subscribe(() => {this.showOrderAdminProgressBar = false; this.filterForm.enable();
      });

  }

  selectFile(event, type) {
    if (type == 'primary') {
      this.selectedFiles = event.target.files;
    }
    else {
      this.selectedSecondaryFiles = event.target.files;
    }

  }

  private getYearPeriods() {
    this.dataService.getYearperiods({param: 'include-all'}).subscribe(yearperiods => {
      this.yearperiods = yearperiods;
    });
  }

  goTo(productOrderedID: string) {
    let data = {}
    data['page'] = this.paginator.pageIndex+1
    data['pageSize'] = this.paginator.pageSize
    localStorage.setItem('orders-reportages', JSON.stringify(data))
    this.router.navigateByUrl(`order-reportage/${productOrderedID}`);
  }

  public setPrinter(printer) {
    console.log(printer)
    this.selectedPrinter = printer
  }

  printLabel(type: string) {
    this.routeSub = this.route.params.subscribe(params => {
      this.dataService.printLabel(params.reference, type, '', this.selectedPrinter).subscribe(res => {
        if (res == 'ok') {
          this.translate.get('alerts.label_printed').subscribe((res: string) => {
            this.snackbar.openFromComponent(CustomPopupComponent, { data: res, duration: 4000})
          })
        }
        else {
          this.translate.get('alerts.print_error').subscribe((res: string) => {
            this.snackbar.openFromComponent(CustomPopupComponent, { data: res, duration: 4000, panelClass: "error-snackbar" })
          })
        }
      })

    })
  }

  applyFilter(reportageID: any = false) {
    // Auto disables filter form when new filters are applied, gets enabled again when fetchOrderedReportageProducts gets API response.
    this.filterForm.disable();

    if (reportageID) {
      localStorage.setItem("order_reportage_filter", this.filterForm.controls["reportages"].value? this.filterForm.controls["reportages"].value : 'all');
    }
    else if(reportageID != false)
    {
      localStorage.setItem("order_reportage_filter", 'all');
    }


    localStorage.setItem("order_year_period", this.filterForm.controls["yearPeriod"].value);

    this.showOrderAdminProgressBar = true
    // const filterValue = (event.target as HTMLInputElement).value;
    // this.dataSource.filter = filterValue.trim().toLowerCase();
    var params = {};
    params['page'] = 1
    params['size'] = this.pageSize
    params['reportage_id'] = this.filterForm.controls["reportages"].value;
    params['unprocessed'] = this.filterForm.controls["unprocessed_only"].value;
    // params['line_id'] = this.filterForm.controls["lines"].value;
    params['search'] = (<HTMLInputElement>document.getElementById("input")).value;
    params['year_period'] = this.filterForm.controls["yearPeriod"].value;

    localStorage.setItem('reportages_unprocessed_only_filter', (this.filterForm.controls["unprocessed_only"].value).toString())

    this.pageIndex = 0
    this.paginator.firstPage()

    this.fetchOrderedReportageProducts(params);

    this.fetchTotalOrderedReportageProducts(params);

    this.clearFilterButtonState();
  }

  clearFilters() {

    localStorage.removeItem("order_reportage_filter");

    this.filterForm.controls["reportages"].setValue('')


    this.stages = []
    this.grades = []

    this.applyFilter(null)

  }



  onPaginateChange(event: PageEvent) {

    this.showOrderAdminProgressBar = true;

    this.pageSize = event.pageSize
    var params = {};


    params['page'] = event.pageIndex + 1
    params['size'] = this.pageSize
    params['role'] = ''
    params['reportage_id'] = this.filterForm.controls["reportages"].value;
    params['search'] = (<HTMLInputElement>document.getElementById("input")).value;
    params['unprocessed'] = this.filterForm.controls["unprocessed_only"].value;
    params['year_period'] = this.filterForm.controls["yearPeriod"].value;


    this.dataService.getReportageProductsOrdered(params).pipe(
      map((tableData: ProductOrdered) => this.dataSource = tableData)
    ).subscribe(() => this.showOrderAdminProgressBar = false)

    // let page = event.pageIndex;
    // let size = event.pageSize;

    // page = page + 1;

    // var params={};
    // params['catalogue'] = this.filterForm.controls["catalogue"].value;
    // params['theme'] = this.filterForm.controls["theme"].value;
    // params['page'] = page;
    // params['size'] = size;
    // this.dataService.getSchools(params).subscribe(schools => {
    //   this.schools = schools;
    //   this.dataSource.data = this.schools;

    //   // this.dataSource.filter = '';


    // });
  }
  processProduct(productOrderedID, status) {
    if ((status == 'reserved') || (status == 'reviewed') || (status == 'paid') || (status == 'lab')) {
      this.dataService.processProductOrdered(productOrderedID).subscribe(res => {
        if (res == 'ok') {
          if (this.isList == true) {
            this.applyFilter(null)
          }
          else {
            this.routeSub = this.route.params.subscribe(params => {
              this.dataService.getProductsOrder(params).subscribe(orders => {
                this.productsOrder = orders;
                this.reportage_name = orders[0].reportage_name
                this.dataSource2.data = this.productsOrder;
                this.status = orders[0].order_status
              }),
                console.error
            })
          }
        }
        else {
          this.translate.get('alerts.product_process_error').subscribe((res: string) => {
            this.snackbar.openFromComponent(CustomPopupComponent, { data: res, duration: 4000, panelClass: "error-snackbar" })
          })
        }
      })
    }
  }

  processAllProducts() {
    this.routeSub = this.route.params.subscribe(params => {

      this.dataService.processAllProductOrdered(params).subscribe(res => {
        
        if (res == 'ok') {
          this.dataService.getProductsOrder(params).subscribe(orders => {
            this.productsOrder = orders;
            this.reportage_name = orders[0].reportage_name
            this.dataSource2.data = this.productsOrder;
            this.status = orders[0].order_status
          }),
            console.error
        }
        else {
          this.translate.get('alerts.product_process_all_error').subscribe((res: string) => {
            this.snackbar.openFromComponent(CustomPopupComponent, { data: res, duration: 4000, panelClass: "error-snackbar" })
          })
        }
      })
    })
  }
  
  downloadInvoice(urlPhoto: string) {
    this.dataService.getFile(urlPhoto, 'application/pdf').subscribe(res => {
      let name = urlPhoto.split('/')

      var blob = new Blob([res], {type: 'application/pdf'});
      var link = document.createElement('a');
      link.href = window.URL.createObjectURL(blob);
      link.setAttribute("target", "_blank");
      link.download = name[1] + '.pdf';
      link.click();
    })

  }

}
export class ProductOrdered {
  constructor(
    public name: string,
    public last_name: string,
    public email: string,
    public id: string,
    public role: string
  ) { }
}
